import { Appointment } from "@drl/shared/models";

export class AppointmentBulk {
    appointments: Appointment[]
    constructor(data?: Partial<Appointment[]>) {
        this.appointments = data;
    }
}